import React from "react";
import { Slider as ChakraSlider, SliderThumb, SliderTrack, } from "@chakra-ui/react";
export function Slider(props) {
    return (React.createElement(ChakraSlider, { focusThumbOnChange: false, ...props },
        React.createElement(SliderThumb, null),
        React.createElement(SliderTrack, null)));
}
